module.exports = __webpack_public_path__ + "img/Jose-Manuel-Criado.8647bc08.jpg";